module.exports = __webpack_public_path__ + "img/The Fence Company.3f433563.png";